import axios from 'axios';
import { Dispatch } from 'redux';
import USER_STRIPE_SUBSCRIPTIONS_TYPES from './types';
import { ENV_CONFIG } from 'config/environment';
import API_ROUTES from 'services/apiRoutes';
import { getSiteAccessToken } from 'services/storage';

const headers = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
};

export const getUserStripeSubscriptions =
  () =>
  async (dispatch: Dispatch): Promise<any> => {
    dispatch(USER_STRIPE_SUBSCRIPTIONS_TYPES.userStripeSubscriptionsStart());
    const url = `${ENV_CONFIG().API.BASE_URL}${API_ROUTES.USER_STRIPE_SUBSCRIPTIONS}`;
    try {
      const response = await axios.get(url, {
        headers: { ...headers, Authorization: `Bearer ${getSiteAccessToken()}` },
      });
      dispatch(USER_STRIPE_SUBSCRIPTIONS_TYPES.userStripeSubscriptionsSuccess(response.data));
      return Promise.resolve(response);
    } catch (error: any) {
      dispatch(USER_STRIPE_SUBSCRIPTIONS_TYPES.userStripeSubscriptionsError(error.message));
      return Promise.reject(error);
    }
  };
